module.exports = __webpack_public_path__ + "static/media/covi_dis_act.5d591f8f.png";